import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import AppMenuBar from "../features/appbar/AppMenuBar";
import { jwtDecode } from 'jwt-decode';

function PrivateRoute({ children, path }) {
  const loggedInUser = JSON.parse(window.localStorage.getItem("loggedInUser"));
  const userPermission = JSON.parse(
    window.localStorage.getItem("userPermission")
  );

function validateJwtToken(token) {
    try {
        const decoded = jwtDecode(token);
        if (!decoded || !decoded.exp) {
            return false;
        }
        const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
        const isValid = currentTime < decoded.exp; // Check if the token is still valid
        const expireIn = isValid ? (decoded.exp - currentTime) / 3600 : 0;
        return (isValid && expireIn > 3);
    } catch (error) {
        return false;
    }
}
  

  const { pathname } = useLocation();
  
  const pageUrl = {
    "/app_users/paf": "App Users",
    "/app_users/puf": "App Users",
    "/app_users/ew": "App Users",
    "/roles_permission": "Roles and Permissions",
    "/location": "Location",
    "/partner": "Partners",
    "/projects" : "Projects",
    "/form_management": "Form Management",
    "/supervisor_access/state_head": "Supervisors",
    "/supervisor_access/district_head": "Supervisors",
    "/supervisor_access/taluka_head": "Supervisors",
    "/supervisor_access/government": "Supervisors",
    "/advisory_management/pesticide": "Advisory Management",
    "/advisory_management/partner_pesticide": "Advisory Management",
    "/review_images": "Review Images",
  };

  const checkLoggedIn = () => {
    if (
      loggedInUser !== null &&
      loggedInUser !== undefined &&
      loggedInUser.token !== undefined &&
      loggedInUser.token !== null &&
      loggedInUser.token !== "" && 
      validateJwtToken(loggedInUser?.token)
    )
      return true;
    return false;
  };

  if (pathname === "/" && checkLoggedIn() === false) {
    return <React.Fragment>{children}</React.Fragment>;
  } else if (pathname === "/" && checkLoggedIn() === true) {
    return <Navigate to="/form_management" replace />;
  } 
  else if (
    userPermission !== null &&
    userPermission !== undefined &&
    userPermission.includes(pageUrl[pathname]) == false
  ) {
    return <Navigate to="/page_not_found" replace />;
  } 
  else if (checkLoggedIn())
  {
    return (
      <React.Fragment>
        <AppMenuBar />
        {children}
      </React.Fragment>
    );
  }
    
  else return <Navigate to="/" replace />;
}
export default PrivateRoute;
